import { graphqlClient } from '../graphqlClient';

// GraphQL Settings API for admin panel
export async function fetchSettings() {
  const query = `
    query GetAdminSettings {
      getAdminSettings {
        id
        platformName
        timezone
        defaultCurrency
        requireIPWhitelist
        hmacAlgorithm
        signatureHeaderName
        timestampTolerance
        callbackRetryEnabled
        callbackMaxRetries
        callbackRetryDelay
        callbackTimeout
        qrDefaultExpiry
        qrMinAmount
        qrMaxAmount
        emailNotifications
        slackNotifications
        alertThreshold
      }
    }
  `;

  const result = await graphqlClient.query(query);
  return result.getAdminSettings;
}

export async function saveSettings(settings) {
  const mutation = `
    mutation UpdateAdminSettings($input: UpdateAdminSettingsInput!) {
      updateAdminSettings(input: $input) {
        id
        platformName
        timezone
        defaultCurrency
        requireIPWhitelist
        hmacAlgorithm
        signatureHeaderName
        timestampTolerance
        callbackRetryEnabled
        callbackMaxRetries
        callbackRetryDelay
        callbackTimeout
        qrDefaultExpiry
        qrMinAmount
        qrMaxAmount
        emailNotifications
        slackNotifications
        alertThreshold
      }
    }
  `;

  // Filter out read-only or ID fields for the mutation input
  const { id, createdAt, updatedAt, __typename, ...input } = settings;

  const result = await graphqlClient.mutate(mutation, { input });
  return result.updateAdminSettings;
}



